/* Bloom Library — el estante que se RE-APILA.

   🔴 La decisión de diseño que este archivo defiende: al filtrar, las piezas que
   no aplican NO se esconden. Se van al fondo del estante. Dos razones, y las dos
   se ven:

   · Una biblioteca que se vacía al tocar un filtro se siente más chica cada vez
     que la usas. Ésta siempre se ve llena, y lo que cambia es el ORDEN — que es
     justo lo que promete el encabezado ("¿cómo llegas hoy?"): no te quito nada,
     te pongo enfrente lo que te toca.
   · Y deja el descubrimiento vivo: quien vino por "vengo acelerada" sigue viendo
     que existe un ritual de cierre de mes, solo que más abajo.

   Va con `order` del grid, no moviendo nodos: el DOM no se toca, así que el foco
   del teclado no se pierde y no hay reflow de árbol. El movimiento lo pone
   `transition` sobre opacidad y desplazamiento — nada que dispare layout.

   El reposo (sin JS) es: todas las piezas visibles, en su orden natural, y los
   botones son botones normales. La página se lee completa sin una línea de JS. */
(function () {
  const estante = document.getElementById('estante');
  const nota    = document.getElementById('estante-nota');
  if (!estante) return;

  const botones = [...document.querySelectorAll('.animo')];
  const piezas  = [...estante.querySelectorAll('.pieza')];
  if (!botones.length || !piezas.length) return;

  /* El orden natural queda guardado para poder volver a él sin recargar. */
  piezas.forEach((p, i) => p.dataset.orden = i);

  const ROTULO = {};
  botones.forEach(b => ROTULO[b.dataset.animo] = b.textContent.trim().toLowerCase());

  function ordenar(animo) {
    let arriba = 0, abajo = 0;
    const total = piezas.length;

    piezas.forEach(p => {
      const cabe = animo === 'todo' || p.dataset.animo === animo;
      /* Los que aplican conservan su orden relativo arriba; los demás conservan
         el suyo abajo. Sin esto el estante se baraja y se siente aleatorio. */
      p.style.order = cabe ? arriba++ : total + abajo++;
      p.classList.toggle('atras', !cabe && animo !== 'todo');

      /* El respiro solo en las que ENTRAN al frente, y reiniciando la animación
         (quitar y volver a poner la clase en el mismo cuadro no la relanza:
         hay que forzar el reflow leyendo offsetWidth). */
      p.classList.remove('elegida');
      if (cabe && animo !== 'todo') { void p.offsetWidth; p.classList.add('elegida'); }
    });

    if (nota) {
      nota.textContent = animo === 'todo'
        ? ''
        : arriba + (arriba === 1 ? ' práctica para cuando ' : ' prácticas para cuando ')
          + ROTULO[animo] + '. Lo demás sigue abajo.';
    }
  }

  /* ── LA ENTRADA ESCALONADA ───────────────────────────────────────────────
     Catorce tarjetas apareciendo a la vez es una pared. Entran en cascada por
     COLUMNA, no por índice: así el barrido se lee de izquierda a derecha como
     se lee la página, y no como una diagonal de plantilla.
     Se dispara una sola vez por pieza y se desconecta — un estante que se
     re-anima cada vez que subes y bajas cansa. */
  if (!matchMedia('(prefers-reduced-motion: reduce)').matches) {
    piezas.forEach(p => p.classList.add('porentrar'));
    const cols = () => {
      const g = getComputedStyle(estante).gridTemplateColumns.split(' ').length;
      return Math.max(1, g);
    };
    const io2 = new IntersectionObserver((es) => {
      es.forEach(e => {
        if (!e.isIntersecting) return;
        const i = piezas.indexOf(e.target);
        e.target.style.transitionDelay = ((i % cols()) * 65) + 'ms';
        e.target.classList.remove('porentrar');
        io2.unobserve(e.target);
      });
    }, { threshold: .12, rootMargin: '0px 0px -8% 0px' });
    piezas.forEach(p => io2.observe(p));
  }

  botones.forEach(b => {
    b.addEventListener('click', () => {
      botones.forEach(o => {
        const activo = o === b;
        o.classList.toggle('activo', activo);
        o.setAttribute('aria-pressed', activo ? 'true' : 'false');
      });
      ordenar(b.dataset.animo);
    });
  });

  /* ── EL RIEL DEL ARCHIVO ─────────────────────────────────────────────────
     Lo único que hace: apagar el desvanecido del borde cuando ya no hay nada
     más a la derecha. Un degradado permanente MIENTE — dice "sigue" cuando ya
     se acabó, y el que llegó al final se queda esperando algo que no existe.
     El reposo sin JS es el desvanecido puesto, que es el estado correcto:
     al cargar siempre hay más a la derecha. */
  const riel = document.querySelector('.archivo-lista');
  if (riel) {
    const marca = () => {
      const falta = riel.scrollWidth - riel.clientWidth - riel.scrollLeft;
      riel.style.setProperty('--riel', falta > 8 ? '1' : '0');
    };
    riel.addEventListener('scroll', marca, { passive: true });
    addEventListener('resize', marca, { passive: true });
    marca();
  }

  /* ── EL PARALAJE, GENERALIZADO ───────────────────────────────────────────
     🔴 Estaba en UNA sección. Medido: el movimiento vivía en 867 px de 6522, o
     sea el 13% de la página — por eso se sentía quieta aunque "tuviera
     paralaje". Ahora cuelga del atributo `data-deriva` y lo toma cualquier
     sección que lo declare, así que agregar movimiento a un bloque nuevo es
     escribir una palabra en el HTML y no otro observador en el JS.

     Sigue siendo UN número por bloque (-1 a 1) y solo `translate`: nada que
     dispare layout. Un único listener para todas, no uno por sección. */
  const conDeriva = [...document.querySelectorAll('[data-deriva]')];
  if (conDeriva.length && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
    let pedido = false;
    const medir = () => {
      pedido = false;
      const alto = innerHeight;
      for (const b of conDeriva) {
        const r = b.getBoundingClientRect();
        if (r.bottom < 0 || r.top > alto) continue;   /* fuera de pantalla: no se calcula */
        const d = (alto / 2 - (r.top + r.height / 2)) / (alto / 2 + r.height / 2);
        b.style.setProperty('--deriva', Math.max(-1, Math.min(1, d)).toFixed(3));
      }
    };
    addEventListener('scroll', () => {
      if (!pedido) { pedido = true; requestAnimationFrame(medir); }
    }, { passive: true });
    addEventListener('resize', medir, { passive: true });
    medir();
  }

})();
